// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"CategoryManagement--next-sr-only--3clO8mK","w-full":"CategoryManagement--w-full--1J6zbVs"};